var map = {
	"@app/modules/admin/admin.module.ngfactory": [
		"./src/app/modules/admin/admin.module.ngfactory.js",
		0
	],
	"@app/modules/dashboard/dashboard.module.ngfactory": [
		"./src/app/modules/dashboard/dashboard.module.ngfactory.js",
		8
	],
	"@app/modules/dispensation/dispensation.module.ngfactory": [
		"./src/app/modules/dispensation/dispensation.module.ngfactory.js",
		9
	],
	"@app/modules/document-v2/document-v2.module.ngfactory": [
		"./src/app/modules/document-v2/document-v2.module.ngfactory.js",
		1
	],
	"@app/modules/document/document.module.ngfactory": [
		"./src/app/modules/document/document.module.ngfactory.js",
		10
	],
	"@app/modules/entry/entry.module.ngfactory": [
		"./src/app/modules/entry/entry.module.ngfactory.js",
		11
	],
	"@app/modules/external-platform-document/external-platform-document.module.ngfactory": [
		"./src/app/modules/external-platform-document/external-platform-document.module.ngfactory.js",
		4
	],
	"@app/modules/favorite-prescription/favorite-prescription.module.ngfactory": [
		"./src/app/modules/favorite-prescription/favorite-prescription.module.ngfactory.js",
		2
	],
	"@app/modules/health-professional/health-professional.module.ngfactory": [
		"./src/app/modules/health-professional/health-professional.module.ngfactory.js",
		5
	],
	"@app/modules/home/home.module.ngfactory": [
		"./src/app/modules/home/home.module.ngfactory.js",
		6
	],
	"@app/modules/patients/patients.module.ngfactory": [
		"./src/app/modules/patients/patients.module.ngfactory.js",
		12
	],
	"@app/modules/pharmacist/pharmacist.module.ngfactory": [
		"./src/app/modules/pharmacist/pharmacist.module.ngfactory.js",
		3
	],
	"@app/modules/public-document/public-document.module.ngfactory": [
		"./src/app/modules/public-document/public-document.module.ngfactory.js",
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;